import { DeactivateSubModel, SubscriberModel } from "../types";
import { HEADERS, rmlApi } from "./setup";

const addSubscriber = async (data: SubscriberModel, token: string) => {
  try {
    const res = await rmlApi.post("/api/MailingList/Subscribers", data, {
      headers: { ...HEADERS, "X-Xsrf-Token": token },
    });
    return res;
  } catch (error: any) {
    return error?.response;
  }
};

const deactivateSubscriber = async (
  data: DeactivateSubModel,
  token: string,
) => {
  try {
    const res = await rmlApi.put(
      "/api/MailingList/DeactivateSubscribers",
      data,
      {
        headers: { ...HEADERS, "X-Xsrf-Token": token },
      },
    );
    return res;
  } catch (error: any) {
    return error?.response;
  }
};

const checkCaptcha = async (data: string) => {
  try {
    const res = await rmlApi.post("/api/Captcha/Captcha", {
      UserResponse: data,
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (error: any) {
    console.error(error);
    return false;
  }
};

export const subscriberServices = {
  addSubscriber,
  checkCaptcha,
  deactivateSubscriber,
};
